import React, { useEffect, useState } from 'react'
import AdminNavbar from '../Navbar/AdminNavbar'
import { CustomerMasterFindAll, ExpensesEntryAdd, ExpensesEntryDelete, ExpensesEntryFindAll, ExpensesEntryUpdate } from '../Api/All_Api';
import axios from 'axios';
import { toast } from 'react-toastify';
import { AiOutlineDingding } from 'react-icons/ai';
import { Button, DatePicker, Input, Select, Table } from 'antd';
import dayjs from 'dayjs';
import { Option } from 'antd/es/mentions';
import { useNavigate } from 'react-router-dom';
import { MdPayments } from "react-icons/md";
import { PaymentReceiveAdd, PaymentReceiveDelete, PaymentReceiveFindAll, PaymentReceiveGetDataById, PaymentReceiveGetDataForCheckbox, PaymentReceiveShowData ,PaymentReceiveUpdate} from '../Api/Transaction_Api';
import TitleNavbar from '../Navbar/TitleNavbar';


const PaymentReceive = () => {

  const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY"];

  const sessionYear = sessionStorage.getItem('sessionYear');
  const branchId = sessionStorage.getItem('branchId');
  const year = sessionYear

const navigate = useNavigate();
    useEffect(() => {
      if (!sessionYear) {
        sessionStorage.clear();
        navigate('/')
      }
    },[])

  const [errors, setErrors] = useState({
    customerName: "",
    amount: "",
  });

  const [pageSize, setPageSize] = useState(10);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);

  const [paymentReceiveId, setPaymentReceiveId] = useState("");
  const [billDate, setBillDate] = useState(dayjs());
  const [customerName, setCustomerName] = useState("");
  const [amount, setAmount] = useState("");
  const [allCustomer, setAllCustomer] = useState([]);
  const [allPaymentReceiveData, setAllPaymentReceiveData] = useState([]);
   const [payReceiveData, setPayReceiveData] = useState([])

     const [paymentMethod, setPaymentMethod] = useState("Cash");
     const [transferTo, setTransferTo] = useState("");
     const [transactionId, setTransactionId] = useState("");

  const [showForm, setShowForm] = useState(false);
  const [showTable, setShowTable] = useState(true);
  const [updateButton, setUpdateButton] = useState(false);
  const [saveButton, setSaveButton] = useState(true);
  let [totalSelectedAmount, setTotalSelectedAmount] = useState(0);
  const [pendingAmount, setPendingAmount] = useState(0);

  const handleShowForm = () => {
    setShowTable(false);
    setShowForm(true);
  };

    //======Search data from table===============
    const handleSearch = (value) => {
      const filtered = allPaymentReceiveData.filter((item) =>
        Object.values(item).some((val) =>
          val !== null && val !== undefined && val.toString().toLowerCase().includes(value.toLowerCase())
        )
      );
      setFilteredData(filtered);
      setTotalEntries(filtered.length); // Update total entries count after filtering
      setCurrentPage(1);
    };
    //==========Pagination=======================
    const handlePageSizeChange = (value) => {
      setPageSize(value);
    };

  // Fetch Cast Names
  let isExpenseFetched = false;
  useEffect(() => {
    if (isExpenseFetched) return;
    fetchPaymentReceive();
    fetchCustomerNames();
    isExpenseFetched = true;
  }, []);

  const fetchCustomerNames = async () => {
  
    try {
      const response = await axios.get(`${CustomerMasterFindAll}?branchId=${branchId}`);
      if (response.data !== null) {
        setAllCustomer(response.data);
      }
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Customers:", error);
        toast.error("Failed to fetch Customers data");
        isError = true; // Set the flag to prevent double toast
      }
    }
  };


  // ==============Get table data================

  let isError = false;

  const fetchPaymentReceive = async () => {
 
    try {
      const response = await axios.get(`${PaymentReceiveFindAll}?branchId=${branchId}&accYear=${year}`);
      if (response.data !== null) {
        setAllPaymentReceiveData(response.data);
        setFilteredData(response.data); 
        setTotalEntries(response.data.length); 
      }
    } catch (error) {
      if (!isError) {
        // Check if the error has already been triggered
        console.error("Error fetching Payment Receive Data:", error);
        toast.error("Failed to fetch Payment Receive Data");
        isError = true; // Set the flag to prevent double toast
      }
    }
  };

  const columns = [
    {
      title: "Sr.No.",
      dataIndex: "",
      key: "index",
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Sale Bill No",
      dataIndex: "saleBillNo",
      key: "saleBillNo",
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "Received Amount",
      dataIndex: "receievedAmount",
      key: "receievedAmount",
    },
    {
      title: "Edit",
      key: "edit",
      render: (text, record) => (
        <div className=''>
          <span
            type="submit"
            style={{ fontSize: "12px", color: "orange", marginRight: "10px" }}
            onClick={() => handleEditDataButton(record)}
          >
            <i class="fa-solid fa-pen-to-square"></i>
          </span>
        </div>
      ),
    },
    // {
    //   title: "Delete",
    //   key: "delete",
    //   render: (text, record) => (
    //     <div className=''>
    //       <span
    //         type="submit"
    //         style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
    //         onClick={() => handleDeleteData(record)}
    //       >
    //         <i class="fa-solid fa-trash"></i>
    //       </span>
    //     </div>
    //   ),
    // },
  ];

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#000",
            color: "#fff",
            padding: "10px",
            fontSize: "13px",
            borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
          }}
        >
          {children}
        </td>
      ),
    },
  };
//=================================================

//==============================Checkbox Code=============================================

const [selectedRows, setSelectedRows] = useState([]);
//  // Function to handle checkbox change
//  const handleCheckboxChange = (row, isChecked) => {
//   if (isChecked) {
//     // Add the row's amount if checked
//     setSelectedRows([...selectedRows, row]);
//   } else {
//     // Remove the row's amount if unchecked
//     setSelectedRows(selectedRows.filter((selectedRow) => selectedRow !== row));
//   }
// };

// // Calculate the total amount of selected rows
//   totalSelectedAmount = selectedRows.reduce(
//   (sum, row) => sum + row.totalAmount,
//   0
// );
// const formattedSelectedData = selectedRows.map((row) => ({
//   saleBillNo: row.saleBillNo
// }));



//===========================================================================

  // ========Cancel data save==================

  const handleCancelShowData= () => { 
    setPayReceiveData([]);
    setSelectedRows([]);
    setErrors("");
    setBillDate(dayjs());
    setCustomerName("");
    setAmount("");

  }
  const handleShowData= async() => { 
    let isValid = true;
    const errorObj = {};

    if (!billDate) {
      isValid = false;
      errorObj.billDate = "Date is required *";
    }
    if (!customerName) {
      isValid = false;
      errorObj.customerName = "Customer Name is required *";
    }
    if (!amount) {
      isValid = false;
      errorObj.amount = "Received Amount is required *";
    }

    setErrors(errorObj);
    if (!isValid) return;


    try {
      // Call the first API for memberTypeName and returnDays
      const PaymentReceiveResponse = await axios.get(`${PaymentReceiveShowData}?branchId=${branchId}&accYear=${year}&customerId=${customerName}`);
  
       if (Array.isArray(PaymentReceiveResponse.data) && PaymentReceiveResponse.data.length === 0) {
          toast.warn("Data not found")
      }    else  if (PaymentReceiveResponse.data !== null) {
        setPayReceiveData(PaymentReceiveResponse.data)
      }  
  
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Failed To Show Data");
    }

  }

  const handleCancel = () => {
    handleCancelForm();
    handleCancelShowData();
    fetchPaymentReceive();
  };

  const handleCancelForm = () => {
    setShowForm(false);
    setShowTable(true);
    setSaveButton(true)
    setUpdateButton(false)
    setPaymentMethod("Cash");
    setTransactionId("");
    setTransferTo("");
    handleCancelShowData();
  };

  // ========Submit data to table==============
  // const handleFormSave = async () => {
  //   let isValid = true;
  //   const errorObj = {};

  //   if (!customerName) {
  //     isValid = false;
  //     errorObj.customerName = "Customer Name is required *";
  //   }
  //   if (!amount) {
  //     isValid = false;
  //     errorObj.amount = "Amount is required *";
  //   }

  //   setErrors(errorObj); // Set error messages

  //   if (!isValid) return;

  //   const formattedDate = billDate
  //   ? dayjs(billDate).format("DD/MM/YYYY")
  //   : "";

  //   const bodyData = {
  //     branchId: parseInt(branchId),
  //     date: formattedDate,
  //     customerId: customerName,
  //     receievedAmount: parseInt(amount),
  //     paymentMode:paymentMethod || null,
  //     transferedTo:transferTo || 0,
  //     transactionId:transactionId || 0,
  //     saleBillNos:formattedSelectedData,
  //     accYear:parseInt(year),
  //     branchId:parseInt(branchId),
  //   };

  //   try {
  //     const response = await axios.post(`${PaymentReceiveAdd}?branchId=${branchId}&accYear=${year}`, bodyData);

  //     if (response.data === "SAVED") {
  //       toast.success("Expense Entry Successfully!");
  //       fetchPaymentReceive();
  //       handleCancel();
  //     } else if (response.data === "ALREADYEXISTS") {
  //       toast.warn("Expense Entry Already Exist !");
  //       handleCancel();
  //     }
  //   } catch (error) {
  //     console.error("Error during API call:", error);
  //     toast.error("Error occurred while submitting data");
  //   }
  // };
  const handleCheckboxChange = (row, isChecked) => {
    if (isChecked) {
      setSelectedRows([...selectedRows, row]);
    } else {
      setSelectedRows(selectedRows.filter((selectedRow) => selectedRow !== row));
    }
  };
  totalSelectedAmount = selectedRows.reduce(
  (sum, row) => sum + row.pendingAmount,
  0
);
  
  // Enhanced handleFormSave logic
  const handleFormSave = async () => {
    let isValid = true;
    const errorObj = {};
  
    if (!customerName) {
      isValid = false;
      errorObj.customerName = "Customer Name is required *";
    }
    if (!amount) {
      isValid = false;
      errorObj.amount = "Amount is required *";
    }
  
    setErrors(errorObj); // Set error messages
  
    if (!isValid) return;
    let remainingAmount = amount; // Start with the entered payment amount
    let pendingAmount = 0; // To track the remaining amount for selected bills
    
    const updatedRows = selectedRows.map((row) => {
      const billAmount = row.pendingAmount; // Original pending amount for the bill
      let receivedAmount = 0; // Amount received for this specific bill
    
      if (remainingAmount >= billAmount) {
        receivedAmount = billAmount; // Fully pay off the bill
        remainingAmount -= billAmount; // Deduct the paid amount
        return { 
          ...row, 
          totalAmount: 0, // No pending amount left
          receivedAmount: receivedAmount, 
          status: "Cleared" 
        };
      } else {
        receivedAmount = remainingAmount; // Partial payment
        const newBillAmount = billAmount - remainingAmount; // Remaining amount after partial payment
        pendingAmount += newBillAmount; // Add the pending amount to track it
        remainingAmount = 0; // Use up all remaining amount
        return { 
          ...row, 
          totalAmount: newBillAmount, // Update pending amount
          receivedAmount: receivedAmount, 
          status: "Pending" 
        };
      }
    });
    
    setSelectedRows(updatedRows);
    
    // Format selected data for API
    const formattedSelectedData = updatedRows.map((row) => ({
      saleBillNo: row.saleBillNo,
      pendingAmount: row.totalAmount, // Pass the pending amount for each bill
      receivedAmount: row.receivedAmount // Pass the received amount for each bill
    }));
    
    console.log(formattedSelectedData); // Debug output to check the formatted data
    
  
    const formattedDate = billDate
      ? dayjs(billDate).format("DD/MM/YYYY")
      : "";
  
    const bodyData = {
      branchId: parseInt(branchId),
      date: formattedDate,
      customerId: customerName,
      receievedAmount: parseInt(amount),
      paymentMode: paymentMethod || null,
      transferedTo: transferTo || 0,
      transactionId: transactionId || 0,
      saleBillNos: formattedSelectedData, // Pass the detailed bill information
      accYear: parseInt(year),
      pendingAmount, // Pass the total pending amount from selected bills
      
    };
  
    try {
      const response = await axios.post(
        `${PaymentReceiveAdd}?branchId=${branchId}&accYear=${year}`,
        bodyData
      );
  
      if (response.data === "SAVED") {
        toast.success("Payment Recieved Successfully!");
        fetchPaymentReceive();
        handleCancel();
      } else if (response.data === "ALREADYEXISTS") {
        toast.warn(" Already Exist !");
        handleCancel();
        fetchPaymentReceive();
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error("Error occurred while submitting data");
    }
  };
  
  const handleFormUpdate = async () => {
    let isValid = true;
    const errorObj = {};
  
    if (!customerName) {
      isValid = false;
      errorObj.customerName = "Customer Name is required *";
    }
    if (!amount) {
      isValid = false;
      errorObj.amount = "Amount is required *";
    }
  
    setErrors(errorObj); // Set error messages
  
    if (!isValid) return;
    let remainingAmount = amount; // Start with the entered payment amount
    let pendingAmount = 0; // To track the remaining amount for selected bills
    
    const updatedRows = selectedRows.map((row) => {
      const billAmount = row.pendingAmount; // Original pending amount for the bill
      let receivedAmount = 0; // Amount received for this specific bill
    
      if (remainingAmount >= billAmount) {
        receivedAmount = billAmount; // Fully pay off the bill
        remainingAmount -= billAmount; // Deduct the paid amount
        return { 
          ...row, 
          totalAmount: 0, // No pending amount left
          receivedAmount: receivedAmount, 
          status: "Cleared" 
        };
      } else {
        receivedAmount = remainingAmount; // Partial payment
        const newBillAmount = billAmount - remainingAmount; // Remaining amount after partial payment
        pendingAmount += newBillAmount; // Add the pending amount to track it
        remainingAmount = 0; // Use up all remaining amount
        return { 
          ...row, 
          totalAmount: newBillAmount, // Update pending amount
          receivedAmount: receivedAmount, 
          status: "Pending" 
        };
      }
    });
    
    setSelectedRows(updatedRows);
    
    // Format selected data for API
    const formattedSelectedData = updatedRows.map((row) => ({
      saleBillNo: row.saleBillNo,
      pendingAmount: row.totalAmount, // Pass the pending amount for each bill
      receivedAmount: row.receivedAmount // Pass the received amount for each bill
    }));
    
    console.log(formattedSelectedData); // Debug output to check the formatted data
  
    const formattedDate = billDate
      ? dayjs(billDate).format("DD/MM/YYYY")
      : "";
  
    const bodyData = {
      id:paymentReceiveId,
      branchId: parseInt(branchId),
      date: formattedDate,
      customerId: customerName,
      receievedAmount: parseInt(amount),
      paymentMode: paymentMethod || null,
      transferedTo: transferTo || 0,
      transactionId: transactionId || 0,
      saleBillNos: formattedSelectedData, // Pass the detailed bill information
      accYear: parseInt(year),
      pendingAmount, // Pass the total pending amount from selected bills
    };
  
    try {
      const response = await axios.put(
        `${PaymentReceiveUpdate}?branchId=${branchId}&accYear=${year}`,
        bodyData
      );
  
      if (response.data === "UPDATED") {
        toast.success("Updated Payment Recieved Successfully!");
        fetchPaymentReceive();
        handleCancel();
      } else if (response.data === "ALREADYEXISTS") {
        toast.warn(" Already Exist !");
        handleCancel();
        fetchPaymentReceive();
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error("Error occurred while submitting data");
    }

  };

  // ========Update data from table============
  const handleEditDataButton = (data) => {
    setUpdateButton(true);
    setSaveButton(false);
    setShowForm(true);
    setShowTable(false);
    window.scrollTo(0, 0);

    handleEditData(data.id)
  };

  // const handleEditData = async (selectedBillNo) => {
  //   try {
  //     const response = await axios.get(`${PaymentReceiveGetDataById}?saleBillNo=${selectedBillNo}&branchId=${branchId}&accYear=${year}`);
  //     const PayReceiveDataArray = response.data;

  //     if (Array.isArray(PayReceiveDataArray) && PayReceiveDataArray.length > 0) {
  //       const PayReceiveData = PayReceiveDataArray[0];

  //     setBillDate(PayReceiveData.paymentReceievedDate ? dayjs(PayReceiveData.paymentReceievedDate, 'DD/MM/YYYY') : null);
  //     setCustomerName(PayReceiveData.customerId || '');
  //     setAmount(PayReceiveData.receievedAmount || 0);
  //     setPaymentReceiveId(PayReceiveData.id);
  //     setPaymentMethod(PayReceiveData.paymentMode);
  //     setTransferTo(PayReceiveData.transferedTo);
  //     setTransactionId(PayReceiveData.transactionId);
        
  //       const checkboxResponse = await axios.get(
  //         `${PaymentReceiveGetDataForCheckbox}?customerId=${PayReceiveData.customerId}&date=${PayReceiveData.paymentReceievedDate}&branchId=${branchId}&accYear=${year}`
  //       );
  //       const PayReceiveCheckboxDataArray = checkboxResponse.data;
  
  //       if (
  //         Array.isArray(PayReceiveCheckboxDataArray) &&
  //         PayReceiveCheckboxDataArray.length > 0
  //       ) {
  //         const PayReceiveCheckboxData = PayReceiveCheckboxDataArray.map((item) => ({
  //           ...item,
  //           checked: item.paymentStatus === 1, // Set `checked` based on `paymentStatus`
  //         }));
  
  //         setPayReceiveData(PayReceiveCheckboxData);
  //       } else {
  //         setPayReceiveData([]);
  //       }
  
  //       } else {
  //         toast.error("No data found for the selected ID");
  //       }

  //   } catch (error) {
  //     console.error("Error getting data:", error);
  //     toast.error("Failed to get Payment Receive data");
  //   }
  // }

  const handleEditData = async (payReceiveMainId) => {
    try {
      const response = await axios.get(`${PaymentReceiveGetDataById}?payReceiveMainId=${payReceiveMainId}&branchId=${branchId}&accYear=${year}`);
      const PayReceiveDataArray = response.data;
  
      if (Array.isArray(PayReceiveDataArray) && PayReceiveDataArray.length > 0) {
        const PayReceiveData = PayReceiveDataArray[0];
  
        setBillDate(PayReceiveData.paymentReceievedDate ? dayjs(PayReceiveData.paymentReceievedDate, 'DD/MM/YYYY') : null);
        setCustomerName(PayReceiveData.customerId || '');
        setAmount(PayReceiveData.totalReceivedAmount || 0);
        setPaymentReceiveId(payReceiveMainId);
        setPaymentMethod(PayReceiveData.paymentMode);
        setTransferTo(PayReceiveData.transferedTo);
        setTransactionId(PayReceiveData.transactionId);
  
        const checkboxResponse = await axios.get(
          `${PaymentReceiveGetDataForCheckbox}?payReceiveMainId=${payReceiveMainId}&branchId=${branchId}&accYear=${year}`
        );
        const PayReceiveCheckboxDataArray = checkboxResponse.data;
  
        if (
          Array.isArray(PayReceiveCheckboxDataArray) &&
          PayReceiveCheckboxDataArray.length > 0
        ) {
          const PayReceiveCheckboxData = PayReceiveCheckboxDataArray.map((item) => ({
            ...item,
            checked: item.paymentStatus === 1, // Set `checked` based on `paymentStatus`
          }));
  
          // Filter checked rows and set them as selected rows
          const selectedRowsData = PayReceiveCheckboxData.filter(row => row.checked);
  
          setPayReceiveData(PayReceiveCheckboxData);
          setSelectedRows(selectedRowsData);
  
    
        } else {
          setPayReceiveData([]);
          setSelectedRows([]);
          setTotalSelectedAmount(0);
        }
      } else {
        toast.error("No data found for the selected ID");
      }
    } catch (error) {
      console.error("Error getting data:", error);
      toast.error("Failed to get Payment Receive data");
    }
  };

  

  // const handleUpdate = async () => {
  //   let isValid = true;
  //   const errorObj = {};

  //   if (!customerName) {
  //     isValid = false;
  //     errorObj.customerName = "Customer Name is required *";
  //   }
  //   if (!amount) {
  //     isValid = false;
  //     errorObj.amount = "Amount is required *";
  //   }

  //   setErrors(errorObj); // Set error messages

  //   if (!isValid) return;

  //   const formattedDate = billDate
  //   ? dayjs(billDate).format("DD/MM/YYYY")
  //   : "";

  //   const bodyData = {
  //     id: paymentReceiveId,
  //     date: formattedDate,
  //     customerName: customerName,
  //     amount: amount,
  //   };

  //   try {
  //     const response = await axios.put(ExpensesEntryUpdate, bodyData);

  //     if (response.data === "UPDATED") {
  //       toast.success("Expense Entry Updated!");
  //       fetchPaymentReceive();
  //       handleCancel();
  //     } else if (response.data === "ALREADYEXISTS") {
  //       toast.warn("Expense Entry Already Exist!");
  //       handleCancel();
  //     }
  //   } catch (error) {
  //     console.error("Error during API call:", error);
  //     toast.error("Error occurred while updating data");
  //   }
  // };


  // const handleDeleteData = async (item) => {
  //   const confirmDelete = window.confirm(
  //     `Are you sure you want to delete the Payment Receive Data for "${item.customerName}"?`
  //   );
  //   if (!confirmDelete) return;

  //   try {
  //     const response = await axios.delete(
  //       `${PaymentReceiveDelete}?id=${item.id}&saleBillNo=${item.saleBillNo}`
  //     );
  //     if (response.data === "DELETED") {
  //       toast.success("Payment Receive Data Deleted !");
  //       fetchPaymentReceive();
  //     }
  //   } catch (error) {
  //     console.error("Error during delete operation:", error);
  //     toast.error("Error occurred while deleting the Payment Receive Data");
  //   }
  // };

  //===================================


const navbg = {
  backgroundColor:"#f79400",
  boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
  display: "flex",
  alignItems: "center",
  padding: "5px 10px",
  fontSize: "19px",
  color:"#fff"
}
//=====================================================

  return (
    <>
      <AdminNavbar />

    <div className="p-0 m-0">

        <div
          className="row m-0"
          style={navbg}
        >
          <div
            className="col-12 "
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
          
            <span className="px-md-5" style={{ flexGrow: 1}}>
                {" "}
                <MdPayments /> &nbsp; Payment Receive
              </span>
              <span >
            <TitleNavbar />
            </span>
          </div>

  
        </div>

     
        {showForm && (
          <>
        <div className='row m-0 p-0 pt-5'>
          <div className='col-12 col-lg-2'></div>
          <div className='col-12 col-lg-8'>
   
                <div className='row px-md-2 mt-3  m-0'>           
               
                    <div className="col-12 col-md-6 col-lg-4 pt-2">
                        <label className="labels">Date :</label>
                        <div className="row m-0">
                      <DatePicker
                          value={billDate}
                          onChange={(value) => setBillDate(value)}
                          className="w-100"
                          format={dateFormatList}
                        />
                         
                      </div>
                    </div>                 

                    <div className="col-12 col-md-6 col-lg-4 pt-2">
                        <label className="labels">Customer Name :</label>
                        <div className="row">
                        <Select
                                                value={customerName || undefined}
                                                onChange={setCustomerName}
                                                showSearch
                                                className="w-100"
                                                placeholder="Select Customer"
                                                optionFilterProp="children"
                                              >
                                                {allCustomer.map((customer) => (
                                                  <Option key={customer.id} value={customer.id}>
                                                    {customer.customerName}
                                                  </Option>
                                                ))}
                                              </Select>
                                              {errors.customerName && (
                                                <div className="errorField">{errors.customerName}</div>
                                              )}
                      </div>
                    </div>              

                    <div className="col-12 col-md-6 col-lg-4 pt-2">
                        <label className="labels">Received Amount :</label>
                        <div className="row m-0">
                        <Input
                            value={amount || ''}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="Enter Amount"
                            onKeyPress={(e) => {
                            // Prevent non-numeric characters from being entered
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          />
                          {errors.amount && (
                            <div className="errorField">{errors.amount}</div>
                          )}
                      </div>
                    </div>            

                  <div className="col-12 text-center pt-3">
                    <Button
                      type="submit"
                      className="CancelBtn mx-1"
                      onClick={handleCancelShowData}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      className="SubmitBtn mx-1"
                      onClick={handleShowData}
                    >
                     Show
                    </Button>
            
                  
                  </div>

                </div>  
          

                <div  className='row d-flex justify-content-center p-2 mt-2'>
                  <div className="mt-3 shadow" style={{ paddingTop:"20px",paddingBottom:"30px",backgroundColor: "white",width:"1000px",overflowX:"auto"}}>
                    <table className="w-100 border shadow" >
                      <thead className='border'>
                        <tr style={{ backgroundColor: "#000", color: "#fff", }}>
                          <th className='px-2'>Sale Bill No</th>
                          <th>Date</th>
                          <th>Vehicle No</th>
                          <th>Total Amount</th>
                          <th>Pending Amount</th>
                       
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody style={{ backgroundColor: "#fff", color: "#000" }}>
                        {payReceiveData.map((row, index) => {
                          return ( 
                            <tr key={index}>
                              <td style={{ fontSize: "14px",padding:"0px 10px", }}>{row.saleBillNo}</td>
                              <td style={{ fontSize: "14px" }}>{row.billingDate}</td>
                              <td style={{ fontSize: "14px" }}>{row.vehicleNo}</td>
                              <td style={{ fontSize: "14px" }}>{row.totalAmount}</td>
                              <td style={{ fontSize: "14px" }}>{row.pendingAmount}</td>
                         
                              <td>
                                 <input
                                  type="checkbox"
                                  checked={row.checked}
                                  onChange={(e) => handleCheckboxChange(row, e.target.checked)}
                                />
                              </td>
                            </tr>
                          );
                        })}
                      
                      </tbody>
                    </table>
                  </div>

                <div className="mt-3 row">
                <div className='col-12 col-md-6 col-lg-6'>
                  <strong className='p-1 rounded' style={{backgroundColor:"grey",color:"#fff"}}>Total Selected Amount: {totalSelectedAmount.toFixed(2)} </strong>
                </div>
                <div className='col-12 col-md-6 col-lg-6'></div>
                </div>


                </div>

                <div className='row m-0'>

                
                                  
                                      <div className="col-12 col-md-6 col-lg-3 pt-2">
                                            <label className="labels">Payment Method</label>
                                            <div className="row">
                                            <Select
                                              value={paymentMethod || undefined}
                                              onChange={(value) => setPaymentMethod(value)}
                                              showSearch
                                              className="w-100"
                                              placeholder="Select Method"
                                              optionFilterProp="children"
                                            >
                                                <Option value="Cash">Cash</Option>
                                                <Option value="Upi">UPI</Option>
                                            </Select>
                                            {errors.paymentMethod && (
                                              <div className="errorField">{errors.paymentMethod}</div>
                                            )}
                
                                          </div>
                                        </div>
                           
                                      
                                                  {/* UPI Fields (only visible when "UPI" is selected) */}
                                    {paymentMethod == "Upi" && (                  
                                        <>
                                         <div className="col-12 col-md-6 col-lg-3 pt-2">
                                              <label className="labels">Transfer To:</label>
                                              <div className="row m-0">
                                              <Input
                                                  value={transferTo || ''}
                                                  onChange={(e) => setTransferTo(e.target.value)}
                                                  placeholder="Enter Transfer To"
                                                />
                                                {errors.transferTo && (
                                                  <div className="errorField">{errors.transferTo}</div>
                                                )}
                
                                            </div>
                                          </div>
                
                                          <div className="col-12 col-md-6 col-lg-3 pt-2">
                                              <label className="labels">Transaction ID:</label>
                                              <div className="row m-0">
                                            <Input
                                                  value={transactionId || ''}
                                                  onChange={(e) => setTransactionId(e.target.value)}
                                                  placeholder="Enter Transaction Id"
                                                />
                                                {errors.transactionId && (
                                                  <div className="errorField">{errors.transactionId}</div>
                                                )}
                                            </div>
                                          </div>
                                      </>
                                    )}
                  </div>

                <div
                  className="col-12 p-0 mt-3"
                  style={{ borderBottom: "2px solid #bfb597" }}
                ></div>
          
          </div>
          <div className='col-12 col-lg-2'></div>


          {/* ============MAIN FORM BUTTONS================== */}
          <div className="col-12 text-center pt-3 mb-5">
            <Button
              type="submit"
              className="CancelBtn mx-1"
              onClick={handleCancelForm}
            >
              Cancel
            </Button>
            {saveButton && (
              <Button
                type="submit"
                className="SubmitBtn mx-1"
                onClick={handleFormSave}
              >
                Save
              </Button>
            )}
            {updateButton && (
              <Button
                type="submit"
                className="UpdateBtn mx-1"
                onClick={handleFormUpdate}
              >
                Update
              </Button>
            )}
          </div>

        </div>        
        </>
        )}

            {/*================ Table =========================*/}
                {showTable && (
                  <>
                <div className="row m-0 p-2 mb-5  pt-md-0 mt-3">
                <div className='col-12 col-md-1 col-lg-2'></div>
                  <div  className="col-12 col-md-10 col-lg-8 py-3 shadow border"
                    style={{ marginBottom: "50px", backgroundColor: "white" }}
                  >
        
                      <div className="row ps-2 m-0 mb-2">
                          <div className="col-12 col-md-3 col-lg-1">
                            <Button
                              onClick={handleShowForm}
                              style={{ backgroundColor: "#f8bf28" }}
                            >
                              Add New +
                            </Button>
                          </div>
                          <div className="col-12 col-md-9 col-lg-11"></div>
                      </div>
        
                    <div
                      className="col-12 px-md-5"
                      style={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <div>
                        <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                        <Select
                          defaultValue={pageSize}
                          onChange={handlePageSizeChange}
                          style={{ width: 120, textAlign: "center" }}
                        >
                          <Option value={10}>10</Option>
                          <Option value={20}>20</Option>
                          <Option value={30}>30</Option>
                        </Select>
                      </div>
        
                      <div className="pt-4 pt-md-0">
                        <Input.Search
                          placeholder="Search"
                          onSearch={handleSearch}
                          style={{ width: 200, marginBottom: 16 }}
                        />
                      </div>
                    </div>
        
                    <div style={{ backgroundColor: "white" }}>
                      <Table
                        bordered
                        style={{ padding: "0px 20px", overflowX: "auto" }}
                        columns={columns}
                        dataSource={filteredData}
                        pagination={{
                          pageSize: pageSize,
                          total: totalEntries,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          current: currentPage,
                          onChange: (page) => setCurrentPage(page),
                        }}
                        showSorterTooltip={false}
                        rowKey={(record) => record.id}
                        components={components}
                      />
                    </div>
                  </div>
                  <div className='col-12 col-md-1 col-lg-2'></div>
                </div>
                </>
                )}

      </div>

    </>
  )
}

export default PaymentReceive




//ssssssssssssssssssssssssssssssssssssssssssssssssssssssssfff